import React from 'react';

export const PairedIcon = (props) => {
  const { className = '', label, style = {}, disabled = false, onClick } = props;

  // Set the width based on the label
  const baseWidth = 90;
  const padding = 50;
  const charWidth = 8;
  const width = Math.max(baseWidth, label.length * charWidth + padding);

  // const width = label === "PAIRED" ? 150 : 114;

  return (
    <svg
      className={className}
      style={style}
      width={width}
      height="36"
      viewBox={`0 0 ${width} 36`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={width} height="36" rx="18" fill="#4BD37B" />
      <path
        d="M18.332 17.9993L20.7765 20.3327L25.6654 15.666"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M22.0013 9.66602C17.408 9.66602 13.668 13.4061 13.668 17.9993C13.668 22.5926 17.408 26.3327 22.0013 26.3327C26.5946 26.3327 30.3346 22.5926 30.3346 17.9993C30.3346 13.4061 26.5946 9.66602 22.0013 9.66602ZM22.0013 24.6164C18.3505 24.6164 15.3842 21.6501 15.3842 17.9993C15.3842 14.3486 18.3406 11.3823 22.0013 11.3823C25.662 11.3823 28.6184 14.3486 28.6184 17.9993C28.6184 21.6501 25.662 24.6164 22.0013 24.6164Z"
        fill="black"
      />
      <text
        x={width - 10}
        y="50%"
        dominantBaseline="middle"
        textAnchor="end"
        fontFamily="Euclid Circular A"
        fontSize="14px"
        fill="black"
        fontWeight="bold"
        textLength={width - 50}
        lengthAdjust="spacing"
      >
        {label}
      </text>
    </svg>
  );
};
